const THEME_COLORS = {
  dark: '#1b1b1d',
  light: '#6b6b75',
  dim: '#1a1a2e',
}

export function isStandaloneDisplay() {
  if (typeof window === 'undefined') return false
  const media = typeof window.matchMedia === 'function'
    && window.matchMedia('(display-mode: standalone)').matches
  return Boolean(media || window.navigator.standalone)
}

export function applyStandaloneClass() {
  if (typeof document === 'undefined') return isStandaloneDisplay()
  const sync = () => {
    document.documentElement.classList.toggle('camit-standalone', isStandaloneDisplay())
  }
  sync()
  if (typeof window.matchMedia === 'function') {
    const media = window.matchMedia('(display-mode: standalone)')
    if (media.addEventListener) media.addEventListener('change', sync)
    else if (media.addListener) media.addListener(sync)
  }
  return isStandaloneDisplay()
}

export function applyThemeColor(theme) {
  const color = THEME_COLORS[theme] || THEME_COLORS.dark
  if (typeof document === 'undefined') return color
  let meta = document.querySelector('meta[name="theme-color"]')
  if (!meta) {
    meta = document.createElement('meta')
    meta.setAttribute('name', 'theme-color')
    document.head.appendChild(meta)
  }
  meta.setAttribute('content', color)
  return color
}

export function registerCamitServiceWorker() {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) {
    return Promise.resolve(null)
  }
  if (!import.meta.env.PROD) return Promise.resolve(null)
  return navigator.serviceWorker.register('/sw.js', { scope: '/' })
}
